import { Navigation } from '../../blocks/common/components/nav';

class Main {
  nav = null;
  contactUs = null;

  async init() {
    this.nav = new Navigation();
  }
}

const application = new Main();

application.init();
window['application'] = application;
